export const SUPPORTED_IMAGE_EXTENSIONS = [
    'gif',
    'jpeg',
    'jpg',
    'jfif',
    'pjpeg',
    'pjp',
    'bmp',
    'ico',
    'cur',
    'apng',
    'png',
    'avif',
    'svg',
    'webp',
    'tif',
    'tiff'
];
